/**
 * Fonction qui permet d'afficher le nombre d'éléments avec un mots avec un s ou pas en fonction du nombre.
 *
 * @param {number} count - Nombre d'éléments.
 * @param {string} singularWord - Mot au singulier.
 * @param {string} pluralWord - Mot au pluriel.
 * @returns {string} Description de la valeur de retour.
 */
export function displayAndPluralize(number, singularWord, pluralWord) {
  return number <= 1 ? `${number} ${singularWord}` : `${number} ${pluralWord}`;
}

/**
 * Calcule le nombre de cartes à afficher par ligne en fonction de la largeur d'écran.
 * Utilisé pour déterminer combien de skeletons afficher pendant le chargement.
 *
 * @param {number} width - Largeur actuelle de l'écran en pixels
 * @param {Object} [breakpoints] - Points de rupture pour les différentes tailles d'écran
 * @param {number} [breakpoints.lg=1280] - Breakpoint pour les grands écrans (4 cartes)
 * @param {number} [breakpoints.md=960] - Breakpoint pour les écrans moyens (3 cartes)
 * @param {number} [breakpoints.sm=600] - Breakpoint pour les petits écrans (2 cartes)
 * @returns {number} Nombre de cartes à afficher (1-4)
 * 
 * @example
 * // Écran large (1400px) -> 4 cartes
 * getCardNumber(1400) // 4
 * 
 * @example
 * // Écran moyen (1000px) -> 3 cartes
 * getCardNumber(1000) // 3
 * 
 * @example
 * // Écran petit (700px) -> 2 cartes
 * getCardNumber(700) // 2
 * 
 * @example
 * // Mobile (400px) -> 1 carte
 * getCardNumber(400) // 1
 */
export const getCardNumber = (width, { lg = 1280, md = 960, sm = 600 } = {}) => {
  if (width >= lg) return 4;
  if (width >= md) return 3;
  if (width >= sm) return 2;
  return 1;
}